// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"366a0a31","685":"35859830","986":"822db914"}[chunkId] + ".chunk.css";
};